export default __webpack_public_path__ + "static/media/IntertekExpressLogo.78c23047.svg";